import {createContext, useContext, useEffect, useState} from "react";
import it from "../config/location/it.json";
import en from "../config/location/en.json";

const TranslationsContext = createContext();

let languages = {
    it,
    en
}
for(const lang in languages){
    for (const id in languages[lang]){
        languages[lang][id] = languages[lang][id].split('\n').map(line => {
            return <>
                {line}
                <br/>
            </>
        });
    }
}

const TranslationsProvider = ({children}) => {
    const [currentLang, setCurrentLang] = useState(localStorage.getItem('lang') || 'it');
    const [translations, setTranslations] = useState(languages[currentLang])

    useEffect(() => {
        setTranslations(languages[currentLang]);
        localStorage.setItem('lang', currentLang);
    },[currentLang]);


    const changeLang = (target) => {
        if (!languages[target]){
            target = 'en';
        }

        setCurrentLang(target);
    }

    return <TranslationsContext.Provider value={{ changeLang, translations, currentLang }}>{children}</TranslationsContext.Provider>
};

export default TranslationsProvider;

export const useTranslations = () => {
    return useContext(TranslationsContext);
}